import { render, staticRenderFns } from "./CreateStageFile.vue?vue&type=template&id=a84080da&"
import script from "./CreateStageFile.vue?vue&type=script&lang=js&"
export * from "./CreateStageFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports